import React from 'react';
import { SOCIAL_LINKS, PERSONAL_INFO, NAV_LINKS } from '../constants/data';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__top">
          <a href="#home" className="footer__logo">
            {PERSONAL_INFO.initials.toLowerCase()}<span className="accent">.</span>dev
          </a>
          <nav className="footer__nav">
            {NAV_LINKS.map((link) => (
              <a key={link.href} href={link.href} className="footer__link">
                {link.label}
              </a>
            ))}
          </nav>
          <div className="footer__socials">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
              >
                <img src={social.icon} alt={social.name} />
              </a>
            ))}
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {new Date().getFullYear()} {PERSONAL_INFO.name}</span>
          <a href={`mailto:${PERSONAL_INFO.email}`}>{PERSONAL_INFO.email}</a>
          <span className="footer__built">Built with React · Hosted on Firebase</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
